import gsap from "gsap";

export default function Pagehero() {
  Alpine.data("pagehero", () => ({
    init() {
      if (this.$refs.media) {
        gsap.to(this.$refs.media, {
          yPercent: 25,
          ease: "none",
          scrollTrigger: {
            trigger: this.$el,
            start: "top top",
            end: "bottom top",
            scrub: true,
          },
        });
      }

      if (this.$refs.text) {
        gsap.to(this.$refs.text, {
          opacity: 0,
          ease: "none",
          scrollTrigger: {
            trigger: this.$el,
            start: "top top",
            end: "20% top",
            scrub: true,
          },
        });
      }

      if (this.$refs.headline) {
        gsap.fromTo(
          this.$refs.headline,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.85,
            delay: 0.25,
            ease: "sine.out",
          },
        );
      }
    },
  }));
}
